import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnChanges,
  OnInit,
  SimpleChange,
  SimpleChanges,
  inject,
  input,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

import { CheckoutFacade } from 'ish-core/facades/checkout.facade';
import { Basket } from 'ish-core/models/basket/basket.model';
import { SuccessMessageComponent } from 'ish-shared/components/common/success-message/success-message.component';
import { SpecialValidators } from 'ish-shared/forms/validators/special-validators';

@Component({
  selector: 'ish-basket-order-reference',
  templateUrl: './basket-order-reference.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, SuccessMessageComponent, FormlyModule, TranslateModule, NgClass],
})
export class BasketOrderReferenceComponent implements OnInit, OnChanges {
  private checkoutFacade = inject(CheckoutFacade);
  private cd = inject(ChangeDetectorRef);

  readonly basket = input.required<Basket>();
  readonly multiPageCheckout = input<boolean>(false);

  form = new FormGroup({});
  model: { orderReferenceId: string } = { orderReferenceId: '' };
  fields: FormlyFieldConfig[];

  showSuccessMessage = false;

  ngOnInit() {
    this.fields = [
      {
        key: 'orderReferenceId',
        type: 'ish-text-input-field',
        props: {
          postWrappers: [{ wrapper: 'description', index: -1 }],
          label: 'checkout.orderReferenceId.label',
          maxLength: 35,
          customDescription: {
            key: 'checkout.orderReferenceId.note',
          },
          labelClass: 'col-md-12',
          fieldClass: 'col-md-12',
        },
        validators: {
          validation: [SpecialValidators.noSpecialChars],
        },
        validation: {
          messages: {
            noSpecialChars: 'account.name.error.forbidden.chars',
          },
        },
      },
    ];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.basket()) {
      this.successMessage(changes.basket);
      this.model = { ...this.model, orderReferenceId: this.getOrderReferenceId(this.basket()) };
    }
  }

  private getOrderReferenceId(basket: Basket): string {
    return basket?.attributes?.find(attr => attr.name === 'orderReferenceID')?.value as string;
  }

  private successMessage(basketChange: SimpleChange) {
    if (
      this.getOrderReferenceId(basketChange?.previousValue) !== this.getOrderReferenceId(basketChange?.currentValue) &&
      !basketChange?.firstChange
    ) {
      this.showSuccessMessage = true;
      setTimeout(() => {
        this.showSuccessMessage = false;
        this.cd.markForCheck();
      }, 5000);
    }
  }

  get disabled() {
    return this.form.invalid || (!this.getOrderReferenceId(this.basket()) && !this.form.get('orderReferenceId').value);
  }

  submitForm() {
    if (this.disabled) {
      return;
    }
    this.checkoutFacade.setBasketCustomAttribute({
      name: 'orderReferenceID',
      value: this.form.get('orderReferenceId').value,
    });
  }
}
